/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import * as _ from 'underscore';
import FAQBlock from 'app/components/Subscription/FAQBlock.jsx';
import { Breakpoint } from 'react-socks';
import ToggleControl from 'app/components/common/ToggleControl.jsx';
import SupportedNetworks from 'app/components/Subscription/SupportedNetworks.jsx';

class PricingMatrix extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedRow: -1,
            selectedTerm: 1
        };

        this.goBack = this.goBack.bind(this);
        this.signUp = this.signUp.bind(this);
        this.toggleFeature = this.toggleFeature.bind(this);
        this.matrixAction = this.matrixAction.bind(this);
        this.goToPlan = this.goToPlan.bind(this);
        this.goToPlusTrial = this.goToPlusTrial.bind(this);
        this.generateFeatureDescription = this.generateFeatureDescription.bind(this);
        this.generateFeatureList = this.generateFeatureList.bind(this);
        this.generatePlanColumn = this.generatePlanColumn.bind(this);
        this.generateAgencyBlock = this.generateAgencyBlock.bind(this);
        this.generateMobileFeatureList = this.generateMobileFeatureList.bind(this);
        this.togglePricing = this.togglePricing.bind(this);

    }

    componentDidMount() {

        if (this.props.context !== 'public') {
            if (dataLayer) {
        		dataLayer.push({
        			'event': 'anchor-pageview',
        			'virtualURL': '/vp/account/subscription/compare'
        		});
            }
        }
    }

    goBack() {

        if (this.props.context === 'upgrade') {
            this.props.router.navigate('/account/subscription');
        } else {
            this.props.router.navigate('/account/subscription/new');
        }
    }

    signUp() {

        window.parent.location.href = this.props.app.config.appUrl + "/login/new";

    }

    toggleFeature(e) {

        let row = parseInt(e.currentTarget.dataset.row, 10),
            newRow = row;

        if (row === this.state.selectedRow) {
            newRow = -1;
        }

        this.setState({
            selectedRow: newRow
        });

    }

    matrixAction(e) {
        let constants = this.props.app.config.constants;

        if (this.props.context === 'public') {
            this.signUp();
        } else if (!this.props.user.detail.trialEligible && this.props.user.detail.pubLevel > 1) {
            this.props.router.navigate('/account/subscription?change=true');
        } else {
            this.props.router.navigate('/account/subscription/new?plan=' + e.currentTarget.dataset.plan);
        }

    }

    goToPlan(e) {
        this.props.closePlanChangeBlock();
        this.props.router.navigate('/account/subscription?change=true');
    }

    goToPlusTrial(e) {
        this.props.router.navigate('/account/subscription/plus');
    }

    generateFeatureDescription(i, feature) {
        let className = (this.state.selectedRow === i) ? ' expanded': '',
            clickHandler = (feature.expanded !== '') ? this.toggleFeature : null,
            expandHint = null;

        if (feature.expanded !== '') {
            if (this.state.selectedRow === i) {
                expandHint = (<span className="key-expand-marker"><i className="icon ion-ios-arrow-down"></i></span>);
            } else {
                expandHint = (<span className="key-expand-marker"><i className="icon ion-ios-arrow-forward"></i></span>);
            }
        }

        if (feature.divider) {
            <li key={i} className="section-divider">
                <div className="key-feature-title"></div>
            </li>
        }

        if (feature.sectionTitle) {
            className += " section-title";
        }

        if (feature.borderless) {
            className += " borderless";
        }

        if (clickHandler === null) {
            className += ' no-pointer';
        }

        return (
            <li key={i} className={className} onClick={clickHandler} data-row={i} role='switch' aria-label={`show ${feature.name}`}>
                <div className="key-feature-title">
                    {feature.name} {expandHint}
                </div>
                <div className="key-feature-desc">
                    {feature.expanded}
                </div>
            </li>
        );
    }

    generateFeatureList(i, feature, plan) {
        let className = '',
            clickHandler = null,
            content = null;

        if (feature.divider) {
            return (
                <li key={i} className="section-divider-feature borderless"></li>
            );
        }

        className = (this.state.selectedRow === i) ? feature.class[plan] + ' expanded' : feature.class[plan];
        clickHandler = (feature.expanded !== '') ? this.toggleFeature : null;

        if (feature.borderless !== undefined && feature.borderless) {
            className += " borderless";
        }

        if (clickHandler === null) {
            className += ' no-pointer';
        }

        if (_.isNumber(feature[plan])) {
            content = feature[plan];
        } else if (_.isBoolean(feature[plan])) {
            className += ' matrix-check';
            if (feature[plan]) {
                content = (
                    <i className="icon ion-ios-checkmark-outline"></i>
                );
            } else {
                content = "\u00a0";
            }
        } else {
            content = feature[plan];
        }


        return (
            <li key={i} className={className} onClick={clickHandler} data-row={i} role="switch">
                {content}
            </li>
        );
    }

    generateMobileFeatureList(i, feature, plan) {
        let className = '',
            clickHandler = null,
            content = null,
            mobileFeature = null;

        if (feature.divider && plan === 'proplus') {
            return (
                <li key={i} className="section-divider-feature borderless"></li>
            );
        } else if (feature.divider) {
            return null;
        }

        className = (this.state.selectedRow === i) ? feature.class[plan] + ' expanded' : feature.class[plan];
        clickHandler = (feature.expanded !== '') ? this.toggleFeature : null;

        if (feature.borderless !== undefined && feature.borderless) {
            className += " borderless";
        }

        if (clickHandler === null) {
            className += ' no-pointer';
        }

        if (_.isNumber(feature[plan])) {
            content = (
                <span>{feature.name}: {feature[plan]}</span>
            );
        } else if (_.isBoolean(feature[plan])) {
            className += ' matrix-check';
            if (feature[plan]) {
                content = (
                    <span>{feature.name} <i className="icon ion-ios-checkmark-outline"></i></span>
                );
            }
        } else {
            if (feature[plan] !== "-") {
                if (!feature.prices) {
                    content = (
                        <span>{feature.name}: {feature[plan]}</span>
                    );
                } else {
                    content = (
                        feature[plan]
                    );
                }
            }
        }

        if ((feature.sectionTitle && plan !== 'proplus') || content === null) {
            return null;
        }

        return (
            <li key={i} className={className} data-row={i}>
                <div className="mobile-feature">
                    {content}
                </div>
            </li>
        );
    }


    generatePlanColumn(i, plan, features) {
        let planStyle = 'plan-column ' + plan,
            buttonStyle = 'matrix-button ' + plan,
            planLabel = 'Your Current Plan',
            planAction = this.matrixAction,
            planCode = 1,
            constants = this.props.app.config.constants,
            planSticker = null,
            generateSticker = function() {
                return (
                    <div className={"plan-sticker " + plan}>
                        <span>Most Popular</span>
                    </div>
                );
            };

        if (this.props.context === 'public') {
            planLabel = "Get Started";
        } else {
            switch (plan) {
                case 'basic':
                    planCode = constants.PUB_LEVEL_15;
                    if (this.props.isFreeUser(this.props.user.detail.pubLevel)) {
                        planLabel = "Get Basic";
                    } else if (!this.props.isFreeUser(this.props.user.detail.pubLevel)) {
                        planLabel = "Change Your Plan";
                        buttonStyle += " reverse";
                    }
                    break;

                case 'proplus':
                    planCode = constants.PUB_LEVEL_9;
                    if (this.props.isFreeUser()) {
                        planLabel = "Get Plus";
                    } else if (this.props.isBasicUser(this.props.user.detail.pubLevel) || this.props.isProUser(this.props.user.detail.pubLevel)) {
                        planLabel = "Upgrade to Plus";
                        if (this.props.user.perms.resources.plusTrialAvailable) {
                            let trialEnd = null,
                                now = new Date();
                            if (this.props.user.plan.trialEndsAt) {
                                trialEnd = new Date(this.props.user.plan.trialEndsAt);
                            }
                            if (trialEnd && trialEnd.getTime() < now.getTime()) {
                                planLabel = "Try it Free for 30 days!";
                                planAction = this.goToPlusTrial;
                            }
                        }
                    } else if (!this.props.isPlusUser(this.props.user.detail.pubLevel)) {
                        planLabel = "Change Your Plan";
                        buttonStyle += " reverse";
                    } else {
                        planAction = this.goToPlan;
                    }
                    break;

                case 'pro':
                    planCode = constants.PUB_LEVEL_6;
                    if (this.props.isFreeUser(this.props.user.detail.pubLevel)) {
                        planLabel = "Get Pro";
                    } else if (this.props.isBasicUser(this.props.user.detail.pubLevel)) {
                        planLabel = "Upgrade to Pro";
                    } else if (!this.props.isProUser(this.props.user.detail.pubLevel)) {
                        planLabel = "Change Your Plan";
                        buttonStyle += " reverse";
                    } else {
                        planAction = this.goToPlan;
                    }
                    break;

                default:
                    planAction = this.goToPlan;
                    buttonStyle += " reverse";
                    break;
            }
        }

        if (plan === 'pro') {
            if (this.props.context) {
                planSticker = generateSticker();
            }
        }

        return (
            <div className={planStyle} key={i}>
                {planSticker}
                <div className="plan-header">
                    {plan.replace('proplus', 'Plus')}
                </div>
                <div className="plan-list-container">
                    <Breakpoint desktop only>
                        <ul className="plan-list">
                            {features.map((feature, i) => {
                                return this.generateFeatureList(i, feature, plan);
                            })}
                        </ul>
                    </Breakpoint>
                    <Breakpoint mobile only>
                        <ul className="plan-list">
                            {features.map((feature, i) => {
                                return this.generateMobileFeatureList(i, feature, plan);
                            })}
                        </ul>
                    </Breakpoint>
                </div>
                <div className="plan-action">
                    <button className={buttonStyle} onClick={planAction} data-plan={planCode}>
                        {planLabel}
                    </button>
                </div>
            </div>
        );
    }

    generateStarterBlock() {
        let planLabel = "Your Current Plan",
            planAction = this.matrixAction,
            planCode = 16,
            buttonStyle = "matrix-button starter",
            constants = this.props.app.config.constants;

            if (this.props.context === 'public') {
                planLabel = "Get Started";
            } else {
                if (this.props.isFreeUser() || !this.props.isStarterUser()) {
                    planLabel = "Get Starter";
                } else if (this.props.isStarterUser()) {
                    buttonStyle += " reverse";
                    planAction = this.goToPlan;
                }
            }

        let price = (this.state.selectedTerm === 1) ? this.props.plans[constants.PUB_LEVEL_16].price[this.state.selectedTerm] : '4.16',
            term = this.state.selectedTerm === 1 ? 'month' : 'year';

        return (
            <div className="plan-display">
                <h3>Need a little less? We've got that.</h3>
                <div className="starter-block">
                    <div className="starter-header">Starter Plan</div>
                    <div className="starter-features">
                        <h2>Starter social media automation toolkit. For individuals and beginners.</h2>
                        <ul className="starter-feature-list">
                            <li>
                                <div className="feature-quantity">
                                    ${price} / mo
                                </div>
                                <div className="feature-desc">
                                    {this.state.selectedTerm === 2 ? (
                                        <span>Billed annually</span>
                                    ) : (
                                        <span></span>
                                    )}
                                </div>
                            </li>
                            <li>
                                <div className="feature-quantity">
                                    2
                                </div>
                                <div className="feature-desc">
                                    <Breakpoint desktop only>
                                        Social Profiles<br/>& Pages
                                    </Breakpoint>
                                    <Breakpoint mobile only>
                                        Social Profiles & Pages
                                    </Breakpoint>
                                </div>
                            </li>
                            <li>
                                <div className="feature-quantity">
                                    50 posts / mo
                                </div>
                                <div className="feature-desc">
                                    <Breakpoint desktop only>
                                        25 posts<br/> per social
                                    </Breakpoint>
                                    <Breakpoint mobile only>
                                        25 posts per social
                                    </Breakpoint>

                                </div>
                            </li>
                            <li>
                                <div className="feature-quantity">
                                    3 hour
                                </div>
                                <div className="feature-desc">
                                    Feed updates
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className="plan-action">
                        <button className={buttonStyle} onClick={planAction} data-plan={planCode}>
                            {planLabel}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    generateAgencyBlock() {
        let planLabel = "Your Current Plan",
            planAction = this.matrixAction,
            planCode = 8,
            buttonStyle = "matrix-button agency",
            constants = this.props.app.config.constants;

            if (this.props.context === 'public') {
                planLabel = "Get Started";
            } else {
                if (this.props.isFreeUser()) {
                    planLabel = "Get Agency";
                } else if (!this.props.isAgencyUser(this.props.user.detail.pubLevel)) {
                    planLabel = "Upgrade to Agency";
                } else {
                    buttonStyle += " reverse";
                    planAction = this.goToPlan;
                }
            }

        let price = (this.state.selectedTerm === 1) ? this.props.plans[constants.PUB_LEVEL_8].price[this.state.selectedTerm] : '149.58';

        return (
            <div className="plan-display">
                <h3>Need a lot more? We've got that.</h3>
                <div className="agency-block">
                    <div className="agency-header">Agency Plan</div>
                    <div className="agency-features">
                        <h2>For ${price}/mo you'll get all of the features of Pro and</h2>
                        <ul className="agency-feature-list">
                            <li>
                                <div className="feature-quantity">
                                    250
                                </div>
                                <div className="feature-desc">
                                    <Breakpoint desktop only>
                                        Social Profiles<br/>& Pages
                                    </Breakpoint>
                                    <Breakpoint mobile only>
                                        Social Profiles & Pages
                                    </Breakpoint>
                                </div>
                            </li>
                            <li>
                                <div className="feature-quantity">
                                    1500
                                </div>
                                <div className="feature-desc">
                                    <Breakpoint desktop only>
                                        Sites &<br/>Feeds
                                    </Breakpoint>
                                    <Breakpoint mobile only>
                                        Sites & Feeds
                                    </Breakpoint>
                                </div>
                            </li>
                            <li>
                                <div className="feature-quantity">
                                    2 Minute
                                </div>
                                <div className="feature-desc">
                                    <Breakpoint desktop only>
                                        Feed<br/>Updates
                                    </Breakpoint>
                                    <Breakpoint mobile only>
                                        Feed Updates
                                    </Breakpoint>
                                </div>
                            </li>
                            <li>
                                <div className="feature-quantity">
                                    10
                                </div>
                                <div className="feature-desc">
                                    <Breakpoint desktop only>
                                        Team<br/>Members
                                    </Breakpoint>
                                    <Breakpoint mobile only>
                                        Team Members
                                    </Breakpoint>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className="plan-action">
                        <button className={buttonStyle} onClick={planAction} data-plan={planCode}>
                            {planLabel}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    togglePricing(e) {
        let nextTerm = e.currentTarget.dataset.togglestate === 'true' ? 1 : 2;

        this.setState({
            selectedTerm: nextTerm
        });

    }

    render() {
        let constants = this.props.app.config.constants,
            basicButton = null,
            agencyButton = null,
            proButton = null,
            link = "subscription",
            linkElement = null,
            wrapperClass = 'pricing-matrix-wrapper',
            basicPricing = (
                <div className="pricing-block">
                    <div className="price basic">$8.25 / mo</div>
                    <div className="price-savings">{'\u2014 Billed Annually \u2014'}</div>
                    <div className="price-copy">Automation for primary social platforms. For entrepreneurs and small businesses.</div>
                </div>
            ),
            proPricing = (
                <div className="pricing-block">
                    <div className="price pro">$10.79 / mo</div>
                    <div className="price-savings">{'\u2014 Billed Annually \u2014'}</div>
                    <div className="price-copy">Essential social media automation for businesses and established professionals.</div>
                </div>
            ),
            plusPricing = (
                <div className="pricing-block">
                    <div className="price proplus">$29.95 / mo</div>
                    <div className="price-savings">{'\u2014 Billed Annually \u2014'}</div>
                    <div className="price-copy">Our most powerful social automation tools. For social media power users.</div>
                </div>
            ),
            features = [
                {
                    'name': '',
                    'basic': basicPricing,
                    'pro': proPricing,
                    'proplus': plusPricing,
                    'expanded': '',
                    'class': {
                        'basic':'basic-price',
                        'pro': 'pro-price',
                        'proplus': 'proplus-price'
                    },
                    prices: true
                },
                {
                    'name': 'Social Profiles & Pages',
                    'basic': 3,
                    'pro': 10,
                    'proplus': 15,
                    'expanded': 'Connect your Facebook pages, X (Twitter), and other social profiles to keep them up to date with your freshest content.',
                    'class': {
                        'basic':'feature-bold',
                        'pro': 'feature-bold',
                        'proplus': 'feature-bold'
                    }
                },
                {
                    'name': 'Monthly Posts per Social',
                    'basic': 'Unlimited',
                    'pro': 'Unlimited',
                    'proplus': 'Unlimited',
                    'expanded': 'Unlock posting limits for essential social profiles.',
                    'class': {
                        'basic':'feature-bold',
                        'proplus': 'feature-bold',
                        'pro': 'feature-bold'
                    }
                },
                {
                    'name': 'Monthly Posts to X',
                    'basic': '50',
                    'pro': '50',
                    'proplus': '50',
                    'expanded': 'Monthly posts to each of your X (Twitter) Profiles.',
                    'class': {
                        'basic':'feature-bold',
                        'proplus': 'feature-bold',
                        'pro': 'feature-bold'
                    }
                },
                {
                    'name': 'Sites / Feeds',
                    'basic': 25,
                    'pro': 50,
                    'proplus': 75,
                    'expanded': 'Quickly and efficiently share content to your social profiles with RSS feeds.',
                    'class': {
                        'basic':'feature-bold',
                        'proplus': 'feature-bold',
                        'pro': 'feature-bold'
                    }
                },
                {
                    'name': 'Queued Items',
                    'basic': '15 / social',
                    'pro': '150 / social',
                    'proplus': '500 / social',
                    'expanded': "Fill your queue with items and we'll automatically share them on your daily posting schedule.",
                    'class': {
                        'basic':'',
                        'proplus': '',
                        'pro': ''
                    }
                },
                {
                    'name': 'Have More Socials?',
                    'basic': '-',
                    'pro': 'expandable',
                    'proplus': 'expandable',
                    'expanded': 'Add packages of socials and feeds at any time.',
                    'class': {
                        'basic':'',
                        'proplus': '',
                        'pro': ''
                    }
                },
                {
                    'name': 'Feed Updates',
                    'basic': '1 hour',
                    'pro': '5 minutes',
                    'proplus': '5 minutes',
                    'expanded': 'Distribute new content to your socials almost as fast as you can post it on your site.',
                    'class': {
                        'basic':'',
                        'pro': '',
                        'proplus': ''
                    }
                },
                {
                    'name': 'Calendar',
                    'basic': true,
                    'pro': true,
                    'proplus': true,
                    'expanded': "Easily plan your social media posting.",
                    'class': {
                        'basic':'',
                        'pro': '',
                        'proplus': ''
                    },
                },
                {
                    'name': 'Team Members',
                    'basic': '-',
                    'pro': 2,
                    'proplus': 3,
                    'expanded': 'Share the work accross your team with muiltiple access logins to your dlvr.it account.',
                    'class': {
                        'basic': '',
                        'pro': '',
                        'proplus': ''
                    }
                },
                // {
                //     'name': 'Content Curation',
                //     'basic': true,
                //     'pro': true,
                //     'proplus': true,
                //     'expanded': 'Hand-select items from your feeds to share across your social networks.',
                //     'class': {
                //         'basic': '',
                //         'pro': '',
                //         'proplus': ''
                //     }
                // },
                // {
                //     'name': 'Stats and Insights',
                //     'basic': true,
                //     'pro': true,
                //     'proplus': true,
                //     'expanded': 'See your social media engagement stats all in one place and watch how individual posts perform on each social page.',
                //     'class': {
                //         'basic':'',
                //         'pro': '',
                //         'proplus': ''
                //     }
                // },
                // {
                //     'name': 'Link Shortener',
                //     'basic': true,
                //     'pro': true,
                //     'proplus': true,
                //     'expanded': 'Automatically post shortened links with dlvr.it, bit.ly, or your favorite link shortening service.',
                //     'class': {
                //         'basic':'',
                //         'pro': '',
                //         'proplus': ''
                //     }
                // },
                {
                    'name': 'Auto #hashtags',
                    'basic': '-',
                    'pro': true,
                    'proplus': true,
                    'expanded': 'Automatically add a static set of hashtags to each of your posts. Maximize engagement and traffic.',
                    'class': {
                        'basic':'',
                        'pro': '',
                        'proplus': ''
                    }
                },
                {
                    'name': 'Echo',
                    'basic': '-',
                    'pro': true,
                    'proplus': true,
                    'expanded': 'Auto schedule feed items to reshare hours, days or weeks later.',
                    'class': {
                        'basic':'',
                        'pro': '',
                        'proplus': ''
                    }
                },
                {
                    'name': 'Power Scheduler',
                    'basic': '-',
                    'pro': true,
                    'proplus': true,
                    'expanded': 'Schedule posts to reshare multiple times across your social profiles and pages.',
                    'class': {
                        'basic':'borderless',
                        'pro': 'borderless',
                        'proplus': 'borderless'
                    },
                    'borderless': true
                },
                // {
                //     'name': 'Post to Pinterest',
                //     'basic': '-',
                //     'pro': true,
                //     'proplus': true,
                //     'expanded': 'Share beautiful images to Pinterest from RSS feeds.',
                //     'class': {
                //         'basic': '',
                //         'pro': '',
                //         'proplus': ''
                //     }
                // },
                // {
                //     'name': 'Twitter Inputs',
                //     'basic': '-',
                //     'pro': true,
                //     'agency': true,
                //     'expanded': 'Automatically repost and retweet items from Twitter across your social networks.',
                //     'class': {
                //         'basic':'',
                //         'pro': '',
                //         'agency': ''
                //     }
                // },
                // {
                //     'name': 'RSS Feed Outputs',
                //     'basic': '-',
                //     'pro': true,
                //     'proplus': true,
                //     'expanded': 'Build your own custom RSS feed with content you select.',
                //     'class': {
                //         'basic':'',
                //         'pro': '',
                //         'proplus': ''
                //     }
                // },
                {
                    'name': '',
                    'divider': true,
                    'expanded': '',
                    'borderless': true
                },
                {
                    'name': 'Social Media Power Tools',
                    'basic': '',
                    'pro': '',
                    'proplus': '',
                    'expanded': "",
                    'class': {
                        'basic':'',
                        'pro': '',
                        'proplus': ''
                    },
                    'sectionTitle': true
                },
                {
                    'name': 'Smart Hashtags',
                    'basic': '-',
                    'pro': '-',
                    'proplus': true,
                    'expanded': 'Our AI powered Smart Hashtags analyze your content and automatically add relevant hashtags to your posts.',
                    'class': {
                        'basic':'',
                        'pro': '',
                        'proplus': 'blue'
                    }
                },
                {
                    'name': 'Dynamic #hashtag Pool',
                    'basic': '-',
                    'pro': '-',
                    'proplus': true,
                    'expanded': 'Automatically cycle through a pool of related #hashtags to keep your posts fresh and engaging.',
                    'class': {
                        'basic':'',
                        'pro': '',
                        'proplus': 'blue'
                    }
                },
                {
                    'name': 'Auto Recycle Posts',
                    'basic': '-',
                    'pro': '-',
                    'proplus': true,
                    'expanded': "Introducing EverQueue. Automatically recycle your social media posts. Never let your social media queue run dry.",
                    'class': {
                        'basic':'',
                        'pro': '',
                        'proplus': 'blue'
                    }
                },
                {
                    'name': 'Bulk Scheduler',
                    'basic': '-',
                    'pro': '-',
                    'proplus': true,
                    'expanded': "Schedule weeks worth of social media posts with just a few clicks.",
                    'class': {
                        'basic':'',
                        'pro': '',
                        'proplus': 'blue'
                    }
                },
                {
                    'name': 'CSV Scheduler',
                    'basic': '-',
                    'pro': '-',
                    'proplus': true,
                    'expanded': "Instantly fill your social media posting schedule with your best articles, links and photos.",
                    'class': {
                        'basic':'',
                        'pro': '',
                        'proplus': 'blue'
                    }
                },
                {
                    'name': 'Category Manager',
                    'basic': '-',
                    'pro': '-',
                    'proplus': true,
                    'expanded': "Easily manage your different content types. Create custom content categories, each with its own posting schedule.",
                    'class': {
                        'basic':'',
                        'pro': '',
                        'proplus': 'blue'
                    }
                },
                {
                    'name': 'WordPress Scheduler',
                    'basic': '-',
                    'pro': '-',
                    'proplus': true,
                    'expanded': "Import and schedule your top blog posts for sharing and resharing on social media.",
                    'class': {
                        'basic':'',
                        'pro': '',
                        'proplus': 'blue'
                    }
                }

            ],
            plans = ['basic', 'pro', 'proplus'],
            faqBlock = null,
            matrixHeaderClass = 'matrix-header';

        if (_.isEmpty(this.props.plans) || _.isEmpty(this.props.user)) {
            if (this.props.context !== 'public') {
                return null;
            }
        }

        if (this.props.bannerVisible) {
            wrapperClass += ' banner-adjust';
        }

        if (this.props.context === 'public') {
            wrapperClass = '';
        }

        if (this.props.context !== "public") {
            faqBlock = (
                <div className="matrix-faq-wrapper">
                    <FAQBlock {...this.props} />
                    <div className="matrix-support-block">
                        <a href="https://support.dlvrit.com" target="_blank">We're here to help. Send us your questions.</a>
                    </div>
                </div>
            );
            matrixHeaderClass += ' app';
        }

        if (this.state.selectedTerm === 1) {
            basicPricing = (
                <div className="pricing-block">
                    <div className="price basic">${this.props.plans[constants.PUB_LEVEL_15].price[1]} / mo</div>
                    <div className="price-savings">{'\u2014 Billed Monthly \u2014'}</div>
                    <div className="price-copy">Automation for primary social platforms. For entrepreneurs and small businesses.</div>
                </div>
            );
            proPricing = (
                <div className="pricing-block">
                    <div className="price pro">${this.props.plans[constants.PUB_LEVEL_6].price[1]} / mo</div>
                    <div className="price-savings">{'\u2014 Billed Monthly \u2014'}</div>
                    <div className="price-copy">Essential social media automation for businesses and established professionals.</div>
                </div>
            );
            plusPricing = (
                <div className="pricing-block">
                    <div className="price proplus">${this.props.plans[constants.PUB_LEVEL_9].price[1]} / mo</div>
                    <div className="price-savings">{'\u2014 Billed Monthly \u2014'}</div>
                    <div className="price-copy">Our most powerful social automation tools. For social media power users.</div>
                </div>
            );

            features[0].basic = basicPricing;
            features[0].pro = proPricing;
            features[0].proplus = plusPricing;
        }

        return (
            <div>
                <div className={wrapperClass}>
                    <h1 className={matrixHeaderClass}>Powerful Social Media Automation</h1>
                    <div className="term-toggle">
                        <span className={"monthly" + (this.state.selectedTerm === 1 ? ' active' : '')}>Monthly</span>
                        <ToggleControl
                            {...this.props}
                            noLabel={true}
                            callback={this.togglePricing}
                            active={(this.state.selectedTerm === 2) ? true : false}/>
                        <span className={"annual" + (this.state.selectedTerm === 2 ? ' active' : '')}>Annual (Save)</span>
                    </div>
                    <Breakpoint desktop only>
                        <div className="pricing-matrix clearfix">
                            <div className="key-column">
                                <ul className="key-list">
                                    {features.map((feature, i) => {
                                        return this.generateFeatureDescription(i, feature);
                                    })}
                                </ul>
                            </div>
                            {plans.map((plan, i) => {
                                return this.generatePlanColumn(i, plan, features);
                            })}
                        </div>
                        {this.generateStarterBlock()}
                        {this.generateAgencyBlock()}
                    </Breakpoint>
                    <Breakpoint mobile only>
                        <div className="pricing-matrix mobile">
                            {plans.map((plan, i) => {
                                return this.generatePlanColumn(i, plan, features);
                            })}
                        </div>
                        {this.generateStarterBlock()}
                        {this.generateAgencyBlock()}
                    </Breakpoint>
                    <SupportedNetworks {...this.props}/>
                    {faqBlock}
                </div>
            </div>
        );
    }

};

PricingMatrix.displayName = "PricingMatrix";

PricingMatrix.propTypes = {
    userPerms: PropTypes.object,
    currentSubscription: PropTypes.object,
    plans: PropTypes.object,
    planDetails: PropTypes.object,
    onPlanUpdate: PropTypes.func,
    context: PropTypes.string,
    trialEligible: PropTypes.bool
};

PricingMatrix.defaultProps = {
    userPerms: {},
    currentSubscription: {},
    plans: {},
    planDetails: {},
    onPlanUpdate: null,
    context: 'upgrade',
    trialEligible: false
};

export default PricingMatrix;
